// Fleet Reports — KPI card (2026-07-14).
// There is no KPI-card / stat-tile component anywhere in src/components, so this
// is new. Design language taken from the app: MUI <Card> (auto 10px radius from
// the theme), the big value on a branding.secondaryColor panel exactly as
// ROI/Result does, 15px bold muted-grey caps header, 13px grey hint.
//
// Branding tints the CHROME (the value panel). It never tints the RAG direction
// hint — see ragColors.js.
import React from "react";
import { useSelector } from "react-redux";
import { Card } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import CardSkeleton from "components/Card Skeleton";

// value: number | null   (null renders "No data", never 0 — an absence is not a zero)
// better: 'higher' | 'lower'
export default function StatTile({ label, value, unit, better = "lower", decimals = 2, loading, pending }) {
  const metaDataValue = useSelector((state) => state.metaData);
  const accent = metaDataValue.branding?.secondaryColor || "#607d8b";

  if (loading) return <CardSkeleton />;

  const hasValue = value !== null && value !== undefined && !Number.isNaN(value);
  const display = pending ? "-" : hasValue ? Number(value).toFixed(decimals) : "No data";

  return (
    <Card style={{ overflow: "hidden", height: "100%" }}>
      <div style={{ padding: "12px 14px 8px 14px" }}>
        <p
          style={{
            fontSize: "15px",
            fontWeight: "bold",
            color: "#333333",
            margin: 0,
            textTransform: "uppercase",
            letterSpacing: "0.3px",
          }}
        >
          {label}
        </p>
      </div>
      <div
        style={{
          background: accent,
          color: "#ffffff",
          padding: "14px",
          textAlign: "center",
        }}
      >
        <span style={{ fontSize: hasValue && !pending ? "30px" : "18px", fontWeight: "bold", lineHeight: 1.1 }}>
          {display}
        </span>
        {hasValue && !pending && unit ? (
          <span style={{ fontSize: "13px", marginLeft: "6px", opacity: 0.9 }}>{unit}</span>
        ) : null}
      </div>
      <div style={{ padding: "8px 14px 12px 14px", display: "flex", alignItems: "center", gap: "4px" }}>
        {pending ? (
          <span style={{ fontSize: "13px", color: "grey" }}>Coming in the next release</span>
        ) : (
          <>
            {better === "higher" ? (
              <ArrowUpwardIcon style={{ fontSize: "14px", color: "grey" }} />
            ) : (
              <ArrowDownwardIcon style={{ fontSize: "14px", color: "grey" }} />
            )}
            <span style={{ fontSize: "13px", color: "grey" }}>
              {better === "higher" ? "higher is better" : "lower is better"}
            </span>
          </>
        )}
      </div>
    </Card>
  );
}
